import { tabVariantsAnimation } from '@/theme/theme';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useMemo, useState } from 'react'
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import theme from '@/theme/theme';
import { GalleryItem } from '@/types';

type GalleryType = {
    gallery: GalleryItem[] | null | undefined
    loading: boolean
}

const Gallery: React.FC<GalleryType> = ({ loading, gallery }) => {

    const [index, setIndex] = useState<number>(-1)

    const slides = useMemo(() => {
        return gallery?.map((item) => (
            { src: item.image }
        ))
    }, [gallery])
    
    return (

        <motion.div
            variants={tabVariantsAnimation}
            animate='animate'
            initial='initial'
        >

            <div className='grid grid-cols-2 lg:grid-cols-3 gap-2 min-h-[50vh]'>
                {!loading ? gallery?.map((item, ind) => (

                        <img key={ind} onClick={() => setIndex(ind)} className='lg:col-span-1 hover:cursor-pointer' src={item.image} />

                    )) :
                    Array(9).fill(null).map(() => (
                        <div className="col-span-1 lg:col-span-1 flex animate-pulse items-center justify-center h-40 lg:h-60 bg-gray-300 rounded w-full dark:bg-gray-700">
                            <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                            </svg>
                        </div>

                    ))
                }
                {gallery === null &&
                    <div className='text-center col-span-3 w-full text-gray-500 italic'> No Images </div>}

            </div>

            <Lightbox
                styles={{
                    container: {
                        backgroundColor: 'rgba(1,1,1,0.9)'
                    }
                }}
                index={index}
                slides={slides}
                open={index >= 0}
                close={() => setIndex(-1)}
            />

        </motion.div>

    )

}

export default Gallery
